import { CloseIcon, FilterIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Button, Drawer, Typography } from '@global-engineering-shared/gweb-material-ui';
import React, { useState } from 'react';

import { useFilters } from 'context/FilterProvider/FilterProvider';
import useStyles from 'features/Filters/Filter.styles';
import FilterPanel from 'features/Filters/FilterPanel/FilterPanel';
import { Filter as FilterType } from 'features/Filters/types/Filters';
import { areFiltersDefault } from 'features/Filters/utils/areFiltersDefault';
import { getNumberOfActiveFilters } from 'features/Filters/utils/getNumberOfActiveFilters';

type FilterProps = {
  filterValues: FilterType[];
};

const Filter = ({ filterValues }: FilterProps) => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const { filters } = useFilters();

  return (
    <div className={classes.main}>
      <div className={classes.filterButtonContainer}>
        <Button
          variant="outlined"
          onClick={() => setDrawerOpen(!drawerOpen)}
          className={classes.filterButton}
          startIcon={<FilterIcon />}
        >
          <Typography className={classes.filterButtonText}>Filter</Typography>
          <div className={classes.circle} hidden={areFiltersDefault(filters)}>
            {getNumberOfActiveFilters(filters)}
          </div>
        </Button>
      </div>
      <Drawer
        className={classes.filterDrawer}
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(!drawerOpen)}
      >
        <div className={classes.filterDrawerDiv}>
          <div>
            <Typography variant="h3" fontWeight="bold" className={classes.filterTypography}>
              Filters
            </Typography>
            <CloseIcon
              data-testid="cross-light-icon"
              onClick={() => setDrawerOpen(false)}
              className={classes.closeIcon}
            />
          </div>
          <FilterPanel setDrawerOpen={setDrawerOpen} filterValues={filterValues} />
        </div>
      </Drawer>
    </div>
  );
};
export default Filter;
